export default {
    account_banned_message:
        'Your account has been disabled for violating our {tos}',
    tos: 'Term Of Service',
    username: 'Username',
    password_new: 'New Password',
    password: 'Password',
    password_confirmation: 'Confirm Password',
    password_placeholder: '8 to 32 characters',
    login_title: 'Nice to see you again',
    create_new_account: 'Create an Account!',
    dont_have_account: 'New to 1Byte?',
    forgot_password: 'Forgot your password?',
    remaining_warning_message:
        'Invalid username or password. You have {remaining} attempts before your account is blocked for {blockedTime} minutes.',
    temporarily_blocked: 'Temporarily Blocked',
    account_locked:
        'Your account has had too many failed login attempts. Please try again after {blockedTime} minutes',
    account_banned: 'Account banned',
    two_fa_status: {
        enabled: 'Enabled',
        enabling: 'Enabling',
        disabled: 'Disabled',
        disabling: 'Disabling',
    },
    authentication_code: 'Authentication Code',
    two_factor_authentication: 'Two-Factor Authentication',
    two_factor_authentication_hint:
        'Open the two-factor authenticator (TOTP) app on your mobile device to view your authentication code.',
    scan_barcode: 'Scan this barcode with your app.',
    scan_barcode_hint:
        'Scan the image below with the two-factor authentication app on your phone.',
    enter_digit: 'Enter the six-digit code from the application',
    enter_digit_hint:
        'After scanning the barcode image, the app will display a six-digit code that you can enter below',
    authentication_code_desc:
        'Open the two-factor authenticator (TOTP) app on your mobile device to view your authentication code.',
    two_factor_authentication_verified: 'Two-Factor Authentication Verified',
    two_factor_authentication_disabled: 'Two-Factor Authentication Disabled',
    enable_two_factor_confirm_title: 'Do you want enable 2FA?',
    enable_two_factor_confirm_content:
        'You can enable Two-Factor Authentication to increase the security of your account',
    google_login: {
        email_existed:
            'This email address is already associated with a 1Byte account. Use a different email address or login to the existing account',
    },
};
